module.exports = __webpack_public_path__ + "static/media/camera_rtsp.15d6657f.svg";